var map = {
	"./anchor-blue.svg": 2091,
	"./arr-down.svg": 2092,
	"./arr-up.svg": 2093,
	"./arrow-down-blue.svg": 2094,
	"./arrow-down-circle.svg": 2095,
	"./arrow-down.svg": 2096,
	"./arrow-left.svg": 2097,
	"./arrow-right.svg": 2098,
	"./arrow-up-circle.svg": 2099,
	"./arrow-up.svg": 2100,
	"./article.svg": 2101,
	"./basket-light.svg": 2102,
	"./basket.svg": 2103,
	"./btn-arrow-dark.svg": 2104,
	"./btn-arrow-down-blue.svg": 2105,
	"./btn-arrow-down.svg": 2106,
	"./btn-arrow.svg": 2107,
	"./btn-info.svg": 2108,
	"./btn-play.svg": 2109,
	"./calendar.svg": 2110,
	"./chevron-down.svg": 2111,
	"./chevron-left.svg": 2112,
	"./chevron-right.svg": 2113,
	"./chevron-up.svg": 2114,
	"./clock.svg": 2115,
	"./cross.svg": 2116,
	"./curve-shape-narrow-swoosh.svg": 2117,
	"./curve-shape-right.svg": 2118,
	"./curve-shape-short.svg": 2119,
	"./curve-shape.svg": 2120,
	"./download.svg": 2121,
	"./facebook.svg": 2122,
	"./gallery.svg": 2123,
	"./i.svg": 2124,
	"./instagram.svg": 2125,
	"./linkedin.svg": 2126,
	"./live-header-logo.svg": 2127,
	"./logo-open.svg": 2128,
	"./menu-close.svg": 2129,
	"./menu-light.svg": 2130,
	"./minus.svg": 2131,
	"./mute.svg": 2132,
	"./pause.svg": 2133,
	"./play.svg": 2134,
	"./plus.svg": 2135,
	"./profile-light.svg": 2136,
	"./radioff.svg": 2137,
	"./radion.svg": 2138,
	"./read.svg": 2139,
	"./restart.svg": 2140,
	"./scores.svg": 2141,
	"./search.svg": 2142,
	"./shop.svg": 2143,
	"./sorting.svg": 2144,
	"./star.svg": 2145,
	"./symbol.svg": 2146,
	"./text.svg": 2147,
	"./tick.svg": 2148,
	"./ticket.svg": 2149,
	"./tiktok.svg": 2150,
	"./track.svg": 2151,
	"./triangle.svg": 2152,
	"./twitter.svg": 2153,
	"./unmute.svg": 2154,
	"./video.svg": 2155,
	"./watch.svg": 2156,
	"./youtube.svg": 2157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 984;